import React from 'react';
import { ExternalLink, Users, GraduationCap, BookOpen } from 'lucide-react';
import { Button } from '../components/ui/button';
import TutorBirdWidget from '../components/TutorBirdWidget';
import { TUTORBIRD } from '../config/tutorbird';

export default function Portal() {
  return (
    <div>
      <section className="hero-bg py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <span className="font-semibold uppercase tracking-wider text-xs" style={{ color: '#3d94b8' }}>Schüler-Portal</span>
          <h1 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight" style={{ color: '#1a3a5c' }}>
            Dein persönlicher Lernbereich
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            Termine verwalten, Materialien herunterladen, Rechnungen einsehen – alles an einem Ort.
          </p>
        </div>
      </section>

      {/* Quick info cards */}
      <section className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid sm:grid-cols-3 gap-5">
          {[
            { icon: GraduationCap, title: 'Für Schüler', text: 'Eigene Termine, Hausaufgaben und Lernfortschritt einsehen.' },
            { icon: Users, title: 'Für Eltern', text: 'Übersicht über alle Stunden, Rechnungen und Kommunikation.' },
            { icon: BookOpen, title: 'Für Tutoren', text: 'Stundenplan verwalten, Notizen anlegen, Abrechnung automatisieren.' },
          ].map((c) => (
            <div key={c.title} className="card-soft p-6">
              <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: '#e6f2f7' }}>
                <c.icon className="h-6 w-6" style={{ color: '#3d94b8' }} />
              </div>
              <h3 className="mt-4 font-bold" style={{ color: '#1a3a5c' }}>{c.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* TutorBird Widgets */}
      <section className="py-12 md:py-16" style={{ background: 'linear-gradient(180deg, #ffffff 0%, #f5f9fb 100%)' }}>
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <div className="card-soft p-6 md:p-8">
            <h2 className="text-xl md:text-2xl font-extrabold" style={{ color: '#1a3a5c' }}>Anmelden</h2>
            <p className="mt-1 text-sm text-slate-600">Melde dich mit deinen Zugangsdaten im Schüler-Portal an.</p>
            <div className="mt-6" data-testid="portal-login-widget">
              <TutorBirdWidget
                src={TUTORBIRD.widgets.login}
                fallbackUrl={TUTORBIRD.portalUrl}
                title="TutorBird Login"
              />
            </div>

            <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 rounded-xl border" style={{ background: '#f5f9fb', borderColor: '#d7ecf4' }}>
              <div className="text-sm text-slate-700">
                <strong>Direktzugang:</strong> Lieber direkt im vollen TutorBird-Portal arbeiten?
              </div>
              <a href={TUTORBIRD.portalUrl} target="_blank" rel="noreferrer">
                <Button variant="outline" className="btn-outline-teal rounded-full">
                  Zum vollen Portal <ExternalLink className="ml-2 h-4 w-4" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-extrabold text-center" style={{ color: '#1a3a5c' }}>So funktioniert's</h2>
          <div className="grid sm:grid-cols-3 gap-6 mt-10">
            {[
              { n: '1', t: 'Zugang erhalten', d: 'Nach der kostenlosen Bedarfsanalyse bekommst du deine Zugangsdaten.' },
              { n: '2', t: 'Termin buchen', d: 'Wähle dein Fach und deinen Wunschtermin.' },
              { n: '3', t: 'Loslegen', d: 'Verbinde dich online mit deinem Tutor.' },
            ].map((s) => (
              <div key={s.n} className="text-center">
                <div className="h-12 w-12 mx-auto rounded-full text-white font-bold flex items-center justify-center shadow-md" style={{ background: 'linear-gradient(135deg, #3d94b8, #2d7d9a)' }}>
                  {s.n}
                </div>
                <h3 className="mt-4 font-bold" style={{ color: '#1a3a5c' }}>{s.t}</h3>
                <p className="mt-2 text-sm text-slate-600">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
